import work_surprise from './work_surprise';
import restuarant_problem from './restuarant_problem';
import vacation from './vacation';

const letters_es = [];
letters_es.push({ name: 'Work Surprise', content:work_surprise });
  letters_es.push({ name: 'Restuarant Problem', content:restuarant_problem });
  letters_es.push({ name: 'Vacation Friend', content:vacation });

export default letters_es;